import React from 'react';
import PropTypes from 'prop-types';
import LoginFooter from '../LoginFooter/LoginFooter';

const SucessResult = ({ handleNav, room, student, notificationsEnabled }) => {
    const autoNav = setTimeout(() => { handleNav(history, room); }, 7500);
    return (
        <div className="grid-y medium-grid-frame">
            <div className="grid-x medium-grid-frame">
                <section className="cell">
                    <div className="grid-y medium-grid-frame grid-padding-x tx-kiosk__content">
                        <div className="cell auto cell-block-container">
                            <div className="cell auto cell-block-container cell-block-y align-middle align-center">
                                <div className="grid-y grid-padding-y tx-kiosk__message">
                                    <i className="icon icon--check-round icon--size--xlarge icon--color--green" title="Meeting Created" aria-hidden="true" />
                                    <h1 className="tx-kiosk__title tx-kiosk__title--large">You’re all set!</h1>
                                    {notificationsEnabled ?
                                        <h2 className="tx-kiosk__copy">A confirmation has been sent via SMS to {student.smsNotificationNumber || student.mobilePhone || student.phone}</h2> :
                                        <h2 className="tx-kiosk__copy">Please stand by until your advisor is ready to meet.</h2>
                                    }
                                </div>
                            </div>
                        </div>
                        <LoginFooter
                            buttonText="Done"
                            onClick={() => {
                                clearTimeout(autoNav);
                                handleNav(history, room);
                            }} />
                    </div>
                </section>
            </div>
        </div>
    );
};

export default SucessResult;

SucessResult.propTypes = {
    handleNav: PropTypes.func,
    notificationsEnabled: PropTypes.bool,
    room: PropTypes.any,
    student: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/login-flow-components/SuccessResult/SuccessResult.jsx